// extracted by mini-css-extract-plugin
export default {"color":"P&C_color__zz914","middleTric":"P&C_middleTric__Yxlg3","iconsColor":"P&C_iconsColor__KPPLi","bgCard":"P&C_bgCard__v-QpY","imgSize2":"P&C_imgSize2__u63tB"};